/**
 * Created by lihanying on 2017/6/29.
 */
import {
  GETCLUBTABLE, GETCLUBTIMEPRICE, GETCLUBTABLETYPE, GETTOTALTYPE, GETCLUBTABLEINFO,
  GETWALLETTYPE, GETQROCODE, GETALLPACKAGE, GETALLOWPACKAGE, GETEDITRECORD
} from './constants'

const initState = {
  allPackage: [],
  allowPackage: []
}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBTABLE:
      return Object.assign({}, state, { clubTable: action.payload })
    case GETCLUBTIMEPRICE:
      return Object.assign({}, state, { timePrice: action.payload })
    case GETCLUBTABLETYPE:
      return Object.assign({}, state, { tableType: action.payload })
    case GETTOTALTYPE:
      return Object.assign({}, state, { totalType: action.payload })
    case GETCLUBTABLEINFO:
      return Object.assign({}, state, { tableInfo: action.payload })
    case GETWALLETTYPE:
      return Object.assign({}, state, { walletType: action.payload })
    case GETQROCODE:
      return Object.assign({}, state, { qrcode: action.payload })
    case GETALLPACKAGE:
      return Object.assign({}, state, { allPackage: action.payload })
    case GETALLOWPACKAGE:
      return Object.assign({}, state, { allowPackage: action.payload })
    case GETEDITRECORD:
      return Object.assign({}, state, { editRecord: action.payload })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubTable/reduce.js